import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom"
import './rsbutton.css'
import leadConvertImg from "../../assets/img/lead-convert.png"
const ActionConvertLead = ({to, onClick, children}) => {
  return (
    <Link
      to={to}
      className={`btn btn-edit`}
      onClick={onClick}
    >
      <img src={leadConvertImg} style={{width:22}} /> {children}
    </Link>
  );
};

ActionConvertLead.propTypes = {
to:PropTypes.string,
onClick: PropTypes.func,
children: PropTypes.string,
};
ActionConvertLead.defaultProps = {
    to:'#',
    onClick: () => {},
    children:''
  };
export default ActionConvertLead;
